import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=82ac4e84&"
import script from "./ModalTitle.vue?vue&type=script&setup=true&lang=js&"
export * from "./ModalTitle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ModalTitle.vue?vue&type=style&index=0&id=82ac4e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports